module.exports = __webpack_public_path__ + "assets/img/645e-tm.svg";